import { lazy, Suspense, type ComponentProps } from 'react';

const MapView = lazy(() => import('./MapView.js').then((m) => ({ default: m.MapView })));

type Props = ComponentProps<typeof MapView>;

export function LazyMapView(props: Props) {
  return (
    <Suspense
      fallback={<div className="h-full w-full animate-pulse rounded-xl border border-slate-200 bg-slate-100" />}
    >
      <MapView {...props} />
    </Suspense>
  );
}
